<template>
    <div>
    <div class="pop_search_bg bgf7 w900">
        <div class="input-group-02">
            <div class="colum-02">
            <div class="form_box-02">
                <label for="code">제조사</label>
                <input type="text" id="code"  class="input-text" placeholder="폭스바겐" value="" autocomplete="off">
            </div>
            </div>
            <div class="colum-02">
            <div class="form_box-02">
                <label for="code">모델명</label>
                <input type="text" id="code"  class="input-text" placeholder="컨버터블" value="" autocomplete="off">
            </div>
            </div>
            <div class="colum-02">
            <div class="form_box-02">
                <label for="code">모델상세</label>
                <input type="text" id="code"  class="input-text" placeholder="컨버터블" value="" autocomplete="off">
            </div>
            </div>
            <div class="colum-02 col-1">
            <div class="form_group">
                <a href="javascript:void(0);" @click="openSelectDetailCarModelPopup" class="account_btn" >조회</a>
            </div>
            </div>
        </div>
    </div>
          <!-- 검색 결과 부분 -->
          <div class="product_sh_result">
            <div class="sub_left_wrap">
              <span>{{this.carName}}</span>
            </div>
            <div class="sub_right_wrap">
              <div class="btn_area pt0">
                <a href="javascript:void(0);" class="button white" v-on:click="openCarModelViewPopup"><span class="fz13">차량모델 보기</span></a>
              </div>
            </div>
          </div>
    <selectDetailCarModelPopup v-on:detail-car-model-complete="detailCarModelComplete" v-model="detailCarModelParam"/>
    <carModelViewPopup v-model="carModelCode"/>
    </div>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import SelectDetailCarModelPopup from '../../common/SelectDetailCarModelPopup.vue'
import CarModelViewPopup from '../../common/CarModelViewPopup.vue'

export default {
    name : 'tabCarVin',
    components : { Grid, GridModule, Vue, SelectDetailCarModelPopup, CarModelViewPopup },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            pushToParent: '', //자식이 부모창으로 전달
            carName: '',
            carModelCode : '',           
            selectBox_options : {
                brandCodeVo : ''
            },
            //팝업관련
            detailCarModelParam : '',
            // 또는 pushToParent: {
            //   data1: '',
            //   data2: '',
            //   data3: ''
            // },
            grid_options : {
                general : {
                id  : 'brand-popup-grid',
                search : '/brand/list',
                // update : '/brand/update',
                //   excel : {
                //     url : '/brand/excel.xls',
                //     fileName : 'brandPopupList'
                //   },
                type : {
                    isUpdate : false,
                    //isHideAdd : true : true,
                },
                PageInfo : {
                },
                params : {
                    searchText: "",
                    //testDate: ""
                }              
                },
                grid_options : {
                    height: 400,
                paging: {
                    pagerTotal : false,
                    hidePageList : true,
                    pagerSelect : false
                },
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        {   width : '30px',            selectorColumn : true   },
                        {   key : 'brandNo',        title : '로고',   width : '150px' }, 
                        {   key : 'brandId',        title : '구분',   width : '138px' }, 
                        {   key : 'brandName',        title : 'SKN 상품코드',   width : '200px' }, 
                        {   key : 'brandEngNamePrefix',    title : '안성물류',   width : '100px' }, 
                        {   key : 'discountRate',     title : '서울물류',       width : '100px' },
                        {   key : 'discountRate',     title : '일반단가',       width : '100px',    align : 'right' },
                        {   key : 'discountRate',     title : '호환상품',       width : '80px' }
                    ]
                }
            }
        }
    },
    created() {

        //console.log("Tab 4(카탈로그)  created    ");
        this.carCatalogueSearchResult = '';

    },
    mounted () {
        //console.log("Tab 4(카탈로그)  mounted    ");

    },
    methods : {
        openSelectDetailCarModelPopup() {
            this.$modal.show('selectDetailCarModelPopup', {});
        },
        detailCarModelComplete(data) {
            //Vue.Alert.alert(data);
            this.carName = data;
        },
        openCarModelViewPopup() {
          this.$modal.show('carModelViewPopup', {});
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/partsCodeSearch/TabCarCatalogue.vue